import { render, staticRenderFns } from "./Keywords.vue?vue&type=template&id=27920754&"
import script from "./Keywords.vue?vue&type=script&lang=js&"
export * from "./Keywords.vue?vue&type=script&lang=js&"
import style0 from "./Keywords.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports